const doc = [({"da":({"js":({"confirm_dialog":({"ok":"OK", "cancel":"Annullér", "confirm":"Bekræft"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;